import { render, staticRenderFns } from "./Esmaltes.vue?vue&type=template&id=a38ff4a6&scoped=true&"
import script from "./Esmaltes.vue?vue&type=script&lang=js&"
export * from "./Esmaltes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38ff4a6",
  null
  
)

export default component.exports